import React, {useState} from "react"

// data and helpers
import Storage from "../../data/storage"

// components
import {ExternalLink, Fixed} from "../controls"

// images and style
import "./Cookies.scss"

// the component
function Cookies({size}) {
  const [hidden, setHidden] = useState(Storage.getCookiesHidden())

  const hide = () => {
    setHidden(true)
    Storage.setCookiesHidden()
  }

  if(hidden) {
    return null
  }

  const onClick = (e) => {
    e.preventDefault()
    hide()
  }

  let text = (
    <div className="text">
      <p>Appentura verwendet Cookies, um die Website bestmöglich an die Bedürfnisse unserer Besucher anpassen zu können.</p>
      <p>Wenn du auf unserer Website weitersurfst, stimmst du der Cookie-Nutzung zu. <ExternalLink to="https://appentura.ch/datenschutz">Klicke hier für weiter Informationen.</ExternalLink></p>
    </div>
  )

  if(size === "large") {
    const button = (
      <div className="button">
        <button onClick={onClick}>Okay</button>
      </div>
    )
    return (
      <Fixed position="bottom" level={2}>
        <div id="s-cookies" className="large">
          <div className="content">
            {text}
            {button}
          </div>
        </div>
      </Fixed>
    )
  }
  else {
    // <button onClick={onClick}>×</button>
    const button = (
      <div className="button">
        <button onClick={onClick}>Okay</button>
      </div>
    )
    return (
      <div id="s-cookies" className="small">
        {text}
        {button}
      </div>
    )
  }
  /*
  return (
    <Media queries={{
      large: "(min-width: 640px)"
    }}>
      {matches => {
        if(matches.large) {
          const button = (
            <div className="button">
              <button onClick={onClick}>Okay</button>
            </div>
          )
          return (
            <Fixed position="bottom" level={2}>
              <div id="s-cookies" className="large">
                <div className="content">
                  {text}
                  {button}
                </div>
              </div>
            </Fixed>
          )
        }
        else {
          const button = (
            <div className="button">
              <button onClick={onClick}>×</button>
            </div>
          )
          return (
            <div id="s-cookies" className="small">
              {text}
              {button}
            </div>
          )
        }
      }}
    </Media>
  )
  */
}

export default Cookies